import { INSERT_COLLAPSIBLE_COMMAND } from '../../Plugins/CollapsiblePlugin';
import { BlockPickerOption } from '../BlockPickerPlugin/BlockPickerOption';
import { c } from 'ttag';
export const CollapsibleBlock = {
    name: c('B3.Notes.EditorToolbar.Action').t `Collapsible`,
    iconName: 'details-block',
    keywords: ['collapse', 'collapsible', 'toggle'],
    onSelect: (editor) => editor.dispatchCommand(INSERT_COLLAPSIBLE_COMMAND, undefined),
};
export function GetCollapsibleBlockOption(editor) {
    return new BlockPickerOption(CollapsibleBlock.name, {
        iconName: CollapsibleBlock.iconName,
        keywords: CollapsibleBlock.keywords,
        onSelect: () => CollapsibleBlock.onSelect(editor),
    });
}
